import _ from "lodash";
import React, { memo } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import PhoneDetails from "./Phones/PhoneDetails";
import AddressesDetails from "./Addresses/AddressesDetails";
import Divider from "../../../../Common/Divider";
import Loader from "../../../../Common/Loader";

const Details = memo(({ customer }) => {
	const isLoading = useSelector(state => state.loader);
	return isLoading && !_.get(customer, `hasDetailsLoaded`) ? (
		<Loader />
	) : (
			<>
				<PhoneDetails customer={customer} />
				<Divider />
				<AddressesDetails customer={customer} />
			</>
		);
});
Details.displayName = `Details`;
Details.propTypes = {
	customer: PropTypes.object
};
export default Details;
